import React, { forwardRef } from 'react';
import { Fab, Badge } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';

interface Position {
  x: number;
  y: number;
}

interface ChatWidgetButtonProps {
  unreadCount: number;
  onClick: () => void;
  onMouseDown?: (e: React.MouseEvent) => void;
  onTouchStart?: (e: React.TouchEvent) => void;
  position?: Position;
  isDragging?: boolean;
}

// Outlook blue theme
const OUTLOOK_BLUE = '#0078D4';

const ChatWidgetButton = forwardRef<HTMLButtonElement, ChatWidgetButtonProps>(({
  unreadCount,
  onClick,
  onMouseDown,
  onTouchStart,
  position = { x: 24, y: 24 },
  isDragging = false,
}, ref) => {
  return (
    <Fab
      ref={ref}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      sx={{
        position: 'fixed',
        bottom: position.y,
        right: position.x,
        backgroundColor: OUTLOOK_BLUE,
        color: 'white',
        '&:hover': {
          backgroundColor: '#106ebe',
        },
        zIndex: 1300,
        cursor: isDragging ? 'grabbing' : 'grab',
        transition: isDragging ? 'none' : 'box-shadow 0.2s',
        boxShadow: isDragging ? '0 8px 20px rgba(0,0,0,0.3)' : undefined,
      }}
    >
      <Badge
        badgeContent={unreadCount}
        color="error"
        max={99}
        sx={{
          '& .MuiBadge-badge': {
            top: -8,
            right: -8,
          },
        }}
      >
        <ChatIcon />
      </Badge>
    </Fab>
  );
});

ChatWidgetButton.displayName = 'ChatWidgetButton';

export default ChatWidgetButton;
